import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Header";
import Home from "./pages/Home";
import Device from "./pages/Device";
import Sensors from "./pages/Sensors";
import BE_Log from "./pages/BE_Log";
import Login from "./pages/Login";
import NoPage from "./pages/NoPage";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="login" element={<Login />} />
                    <Route path="sensors" element={<Sensors />} />
                    <Route path="be_log" element={<BE_Log />} />
                    <Route path="device/:serial" element={<Device />} />
                    <Route path="device/:serial/be_log" element={<BE_Log />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

const backendUrl = process.env.REACT_APP_API_URL;
const isLocal = process.env.REACT_APP_API_URL === '/api';
const isTest = backendUrl.includes("test-");
document.title = isLocal ? "LOCAL AA" : (isTest ? "AA Care4u (test)" : "AA Care4u");
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
